// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__36mpX","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__3izZg"};